import { createSelector } from '@ngrx/store';
import { selectPinnedDataState } from '..';

export const selectPinnedIngestions = createSelector(selectPinnedDataState, (state) => state.pinnedIngestionArr);
export const selectLoadingStatus = createSelector(selectPinnedDataState, (state) => state.pinnedItemLoading);
